<template>
  <div class=" flex w-full my-1 right">
    <div class="chat">
      <div class="flex w-full">
        <div class="mr-4 p-2">
          <div
            @click="viewUser()"
            style="height: 40px; width: 40px;"
            class="cursor-pointer self-start rounded"
          >
            <img
              class="object-cover w-150 h-150 rounded-full"
              src="https://picsum.photos/id/1011/3648.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="w-full">
          <div
            @click="viewUser()"
            class="text-tenant-color font-semibold text-md cursor-pointer mt-1"
          >
            {{ chat.user.first_name }} {{ chat.user.last_name }}
          </div>
          <div class="text-black  mb-6">
            <div>
              {{ chat.message }}
            </div>
            <div class="mb-1 text-xs">
              {{ chat.created_at | fromNow }}
              <span v-if="allowReply">
                | {{ messages.reply_count }} Replies</span
              >
              <span
                class="cursor-pointer"
                v-if="allowReply"
                @click="isReplying = !isReplying"
                >| Reply</span
              >
            </div>
            <div v-if="chat.reply_count">
              <chatBubble
                v-for="chat in messages.replies"
                :key="chat.id"
                :chat="chat"
                :user="chat.user"
                class="w-full"
              />
            </div>
            <chat-box
              v-if="isReplying"
              class="w-full"
              @enter-pressed="handleChat"
              @send="handleChat"
              v-model="message"
            />
          </div>
        </div>
      </div>
    </div>
    <hr class="" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "chatBubble",
  props: {
    allowReply: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    chat: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  data() {
    return {
      isReplying: false,
      message: "",
      messages: [],
    };
  },
  components: {
    chatBox: () => import("@/components/shared/chat/ChatBox"),
    chatBubble: () => import("@/components/shared/chat/ChatBubble"),
  },
  mounted() {
    this.messages = this.chat;
  },
  methods: {
    ...mapActions(["sendReply"]),
    viewUser() {
      this.$router.push({
        name: "learner-discussion-user-details",
        params: { user: this.chat.user.id },
      });
    },
    handleChat() {
      if (this.chat == "") {
        return;
      }
      this.processChat();
    },
    async processChat() {
      let res = await this.sendReply({
        id: this.chat.id,
        message: this.message,
      });
      //console.log({ res });
      this.messages.replies.push(res.data.data.discussion);
      this.message = "";
    },
    getValue(message) {
      try {
        return JSON.parse(message);
      } catch (e) {
        return message;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #000;
  text-decoration: none;
}
.chat {
  width: 100%;
  .message {
    background-color: #ecf0f3;
    border-radius: 5px;
  }

  &:before {
    content: "";
    width: 0px;
    height: 0px;
    display: block;
    border-left: 5px solid transparent;
    border-right: 5px solid #ecf0f3;
    border-top: 5px solid #ecf0f3;
    border-bottom: 5px solid transparent;
    position: absolute;
    top: 0px;
    left: -3px;
  }
}

.right {
  .message {
    background-color: #0087db;
    color: #ffffff;
  }
}
</style>
